module.exports = __webpack_public_path__ + "static/img/matlab_library.742dbd4.svg";